import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Status } from 'src/app/models/survey/status';
import { StatusService } from 'src/app/services/survey/status.service';
import { ActivatedRoute } from '@angular/router';
import { Survey } from 'src/app/models/survey/survey';

@Component({
  selector: 'app-sv-status-form',
  templateUrl: './sv-status-form.component.html',
  styleUrls: ['./sv-status-form.component.scss']
})
export class SvStatusFormComponent implements OnInit {

  formGroup: FormGroup;
  status: Status;
  edit: boolean = false;

  constructor(
    private service: StatusService,
    private fb: FormBuilder,
    private actRoute: ActivatedRoute) {
    this.createForm();
    this.getTeam();
  }

  ngOnInit() {
  }

  createForm() {
    this.formGroup = this.fb.group({
      id: [null],
      label: ['', [Validators.required]],
      detail: ['']
    })
  }

  getTeam() {
    const params = this.actRoute.snapshot.params;
    if (params['id']) {
      this.service.getOne(params['id'])
        .subscribe(
          res => {
            this.status = res['data'];
            this.loadData();
            this.edit = true;
          },
          err => console.error(err)
        );
    } else {
      this.edit = false;
    }
  }

  save() {
    if (this.formGroup.invalid) {
      return Object.values(this.formGroup.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.formGroup.value.id, this.formGroup.value) : this.create(this.formGroup.value);
    }
  }

  create(data: Survey) {
    delete data.id;
    this.service.create(data)
      .subscribe(
        res => {
          console.log("res create: ", res)
        },
        err => console.error(err))
  }

  update(id: string, data: Survey) {
    delete data.id;
    this.service.update(id, data)
      .subscribe(
        res => {
          console.log("res update: ", res)
        },
        err => console.error(err))
  }

  loadData() {
    this.formGroup.reset(this.status);
  }

  campoNoValido(campo: string) {
    return this.formGroup.get(campo).invalid && this.formGroup.get(campo).touched;
  }

}

